const TALLY_URL = "https://tally.so/r/VLv7Ey";

export const Waitlist = () => {
  return (
    <section
      id="waitlist"
      data-testid="waitlist-section"
      className="relative w-full py-28 md:py-44"
      style={{ backgroundColor: "#634F50" }}
    >
      <div className="mx-auto max-w-[900px] px-6 md:px-10 lg:px-14 text-center">
        <h2
          data-testid="waitlist-heading"
          className="font-editorial text-[#F6F2EC] text-5xl md:text-6xl lg:text-7xl leading-[1]"
        >
          Join the <span className="font-editorial-italic">waitlist.</span>
        </h2>

        <p className="mt-10 text-[#F6F2EC]/85 text-lg md:text-xl font-light leading-relaxed max-w-lg mx-auto">
          Membership is intentional and limited. Share a little about yourself — we'll be in touch as we open the doors in Miami.
        </p>

        <a
          href={TALLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="waitlist-cta"
          className="eyebrow text-[#F6F2EC] border-b border-[#F6F2EC] pb-2 hover:opacity-60 transition-opacity inline-block mt-14 md:mt-16"
        >
          Request Invitation
        </a>
      </div>
    </section>
  );
};
